import * as THREE from 'three';
import Random from 'canvas-sketch-util/random';


import Store from '../Store';



export default class DustParticles {
  constructor( count = 100) {
    this.group = new THREE.Group();;
    this.count = count;
    this.particles = [];
    this.mesh = null;
    this.light = null;

    this.init();
  }

  init() {
    const { scene } = Store.getState();

    // Initialize instanced mesh
    const geometry = new THREE.DodecahedronGeometry(0.1, 0);
    const material = new THREE.MeshPhongMaterial({
      color: 0x86827d,
      // opacity: 0.05,
      // transparent: true,
      // depthTest: false,
    });
    this.mesh = new THREE.InstancedMesh(geometry, material, this.count);
    this.group.add(this.mesh);
    this.group.renderOrder = 10;

    // Generate some random positions, speed factors, and timings
    for (let i = 0; i < this.count; i++) {
      const time = Random.range(0, 100);
      const factor = Random.range(20, 120);
      const speed = Random.range(0.01, 0.015) / 4;
      const x = Random.range(-50, 50);
      const y = Random.range(-50, 50);
      const z = Random.range(-50, 50);
      this.particles.push({ time, factor, speed, x, y, z });
    }

    this.dummy = new THREE.Object3D();

    scene.add(this.group);
  }

  update() {
    // Run through the randomized data to calculate some movement
    this.particles.forEach((particle, index) => {
      let { factor, speed, x, y, z } = particle;

      // Update the particle time
      const t = (particle.time += speed);

      // Update the particle position based on the time
      this.dummy.position.set(
        x + Math.cos((t / 10) * factor) + (Math.sin(t * 1) * factor) / 10,
        y + Math.sin((t / 10) * factor) + (Math.cos(t * 2) * factor) / 10,
        z + Math.cos((t / 10) * factor) + (Math.sin(t * 3) * factor) / 10
      );

      // Derive an oscillating value which will be used for particle size and rotation
      const s = Math.cos(t);
      this.dummy.scale.set(s, s, s);
      this.dummy.rotation.set(s * 5, s * 5, s * 5);
      this.dummy.updateMatrix();

      // And apply the matrix to the instanced item
      this.mesh.setMatrixAt(index, this.dummy.matrix);
    });

    this.mesh.instanceMatrix.needsUpdate = true;
  }
}
